"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var componentStyle = {
    base: {
        padding: 18,
    },
    description: {
        marginTop: 0,
    },
};
exports.ExampleBody = function (props) { return (React.createElement("div", { style: componentStyle.base },
    React.createElement(common_1.Paragraph, { style: componentStyle.description, dangerouslySetInnerHTML: { __html: props.description } }),
    props.children)); };
exports.ExampleBody.displayName = 'ExampleBody';



//////////////////
// WEBPACK FOOTER
// ./src/docs/common/Example/ExampleBody.tsx
// module id = 617
// module chunks = 0